import { useEffect } from 'react';
import '../mercado/mis.css';
import { useT } from 'i18n';

const OK = /éxito|exito|creado|creada|recibid|enviad|correcta|guardad|actualizad|listo|aprobad|success|created|saved|updated|approved|received|sent|sucesso|criad|salv|atualizad|aprovad/i;

// Aviso único de la app: mismo estilo en todas las pantallas.
const Mensaje = ({ mensaje, guardarMensajeOpen, guardarMensaje }) => {
  const { t, ts } = useT();
  const cerrar = () => {
    if (guardarMensajeOpen) guardarMensajeOpen(false);
    if (guardarMensaje) guardarMensaje('');
  };

  useEffect(() => {
    const tecla = (e) => { if (e.key === 'Escape') cerrar(); };
    window.addEventListener('keydown', tecla);
    return () => window.removeEventListener('keydown', tecla);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const ok = OK.test(String(mensaje || ''));

  return (
    <div className="p7x-overlay p7x-overlay-aviso" role="alertdialog" aria-modal="true" onClick={cerrar}>
      <div className="p7x-modal p7x-aviso-card" onClick={(e) => e.stopPropagation()}>
        <span className={`p7x-icono ${ok ? 'ok' : 'aviso'}`} aria-hidden="true">{ok ? '✓' : '!'}</span>
        <h2>{ok ? t('alerta.listo') : t('alerta.revisa')}</h2>
        <p>{ts(mensaje)}</p>
        <button type="button" className="p7-btn-gold" onClick={cerrar} autoFocus>{t('alerta.aceptar')}</button>
      </div>
    </div>
  );
};

export default Mensaje;
